export enum FilterGroup {
    All,
    Facilitated,
    NonFacilitated,
    MsOnly,
    KflOnly
}